import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <InfoSection title="Reikningar og greiðsluskilmálar">
            <p>
                Skr&aacute;ningarkr&ouml;fur eru innheimtar og m&oacute;tteknar af
                vi&eth;skiptabanka 1819.
            </p>
            <p>
                Eindagi reikninga er minnst 7 d&ouml;gum eftir gjalddaga. S&eacute; reikningur
                greiddur eftir eindaga grei&eth;ir vi&eth;komandi vi&eth;skiptavinur
                dr&aacute;ttarvexti fr&aacute; gjalddaga til grei&eth;sludags skv. III. kafla laga
                um vexti og ver&eth;tryggingu nr. 38/2001, auk &thorn;ess a&eth; gjald vegna
                innheimtuvi&eth;v&ouml;runar leggst &aacute; kr&ouml;fu vi&eth; &uacute;tsendingu 2
                d&ouml;gum eftir eindaga skv. gjaldskr&aacute; Debitum. &THORN;&aacute; er innheimt
                &uacute;tskriftargjald af hverri kr&ouml;fu samkv&aelig;mt ver&eth;skr&aacute;
                vi&eth;skiptabanka 1819.
            </p>
            <p>
                Vi&eth;skiptavinur ber fulla &aacute;byrg&eth; &aacute; grei&eth;slum vegna notkunar
                &aacute; &thorn;j&oacute;nustu 1819. Reikninga ber að greiða eigi síðar en á
                eindaga.
            </p>
            <p>
                Vi&eth; endurn&yacute;jun skr&aacute;ninga eru gefnir &uacute;t reikningar me&eth;
                sama gjalddaga og vi&eth; upphaf skr&aacute;ningar.
            </p>
            <p>
                Athugasemdir skulu ger&eth;ar vi&eth; &uacute;tgefna reikninga &aacute;n tafar og
                eigi s&iacute;&eth;ar en &aacute; eindaga, ella telst reikningur sam&thorn;ykktur.
                Athugasemdir vegna reikninga skulu sendast &aacute; reikningar[@]1819.is&nbsp;
            </p>
            <p>
                <strong>Innheimtuferli</strong>
            </p>
            <p>
                Debitum sér um milli- og l&ouml;ginnheimtu fyrir 1819. Kostna&eth;ur vi&eth; milli-
                og l&ouml;ginnheimtu er samkv&aelig;mt ver&eth;skr&aacute; Debitum hverju sinni. Ef
                athugasemdir berast vegna hennar mun 1819 taka afst&ouml;&eth;u til &thorn;eirra
                &iacute; samr&aacute;&eth;i vi&eth; vi&eth;komandi fyrirt&aelig;ki.
            </p>
            <p>
                1819 &aacute;skilur s&eacute;r r&eacute;tt til a&eth; fjarl&aelig;gja
                skr&aacute;ningar af mi&eth;lum 1819 komi til vanskila.
            </p>
            <p>&nbsp;</p>
            <p>
                <img
                    style={{ display: "block", margin: "0 auto" }}
                    src="https://old.1819.is/images/Screenshot_2020-10-15_at_15.14_.39_.png"
                    alt=""
                />
            </p>
        </InfoSection>
    );
}
export default ServiceNumber;
